import script from "./whDOnceImg4_t2A.vue?vue&type=script&setup=true&lang=js"
export * from "./whDOnceImg4_t2A.vue?vue&type=script&setup=true&lang=js"

import "./whDOnceImg4_t2A.vue?vue&type=style&index=0&id=90e3c078&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90e3c078"]])

export default __exports__